//This function prevents users from using copy-paste to input invalid values, as onKeyDown doesn't handle this case
export const onlyAllowString = (
  event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
) => {
  // Allow only letters (a-z, A-Z) and spaces
  const filtered = event.target.value.replace(/[^a-zA-Z\s]/g, '')
  event.target.value = filtered
  return filtered
}
